module.exports = __webpack_public_path__ + "img/thumbnail_CollaredPeccary_f_leucistic.704e8e88.png";